import { Login as LoginComponent } from "../../components/login/login-layout-hoc";

const Login = () => {
  return <LoginComponent />;
};

export default Login;
